<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer title="还款详情"  >
			<div>
				<div class="p-1 border-bottom rounded  " role="button" >
					还款流水号
				</div>	
				<div class="p-2  rounded  ml-3 text-primary" role="button" v-if="repayInfo!=null">
					{{repayInfo.requestNo}}
				</div>	
				
				<div class="p-1  rounded  border-bottom" role="button" >
					还款时间
				</div>	
				<div class="p-2  rounded  ml-3 text-primary" role="button" v-if="repayInfo!=null">
					{{repayInfo.createTime}}
				</div>	
				
				<div class="p-1  rounded  border-bottom" role="button" >
					还款金额
				</div>	
				<div class="p-2  rounded  ml-3 text-primary" role="button" v-if="repayInfo!=null">
					{{repayInfo.amount/100}}元
				</div>	
				
				<div class="p-1  rounded  border-bottom" role="button" >
					状态
				</div>	
				<div class="p-2  rounded  ml-3 text-primary" role="button" >
					处理中
				</div>	
		
			</div>
		</b-modal>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				repayInfo:null,
			}
		},

		methods: {
			showModal(_repayInfo) {
				this.repayInfo=_repayInfo;
				this.$refs['publish-modal'].show()
			},
			
			hideModal() {
				this.$refs['publish-modal'].hide()
			},
		
		}
	}
</script>

<style>
	#item:hover {
		background-color:gainsboro;
		border-radius: 5px;
	}
	
</style>
